import { insuranceOption } from '@/common/queries/selections/insurance/insuranceOption';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { getBodyInsuranceOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyInsurance/getBodyInsuranceOptions';
import { patchBodyInsuranceOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyInsurance/patchBodyInsuranceOptions';
import { BodyInsuranceFormType } from '@/modules/adjusterReportModules/Insurer-information/types/BodyInsurance.type';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
const useEditBodyInsurance = () => {
  const methods = useForm<BodyInsuranceFormType>({ mode: 'onChange' });

  const { id } = useParams();
  const [name, setName] = useState<string | null>(null);
  const navigate = useNavigate();
  const clientQuery = useQueryClient();
  const { data: insurances, isPending } = useQuery(
    insuranceOption({ name: name }),
  );

  const { data: BodyInsuranceData, isPending: bodyPending } = useQuery(
    getBodyInsuranceOptions({ id: +id! }),
  );

  const { mutate, isPending: mutationPending } = useMutation(
    patchBodyInsuranceOptions(),
  );
  const submitHandler = (data: BodyInsuranceFormType) => {
    mutate(
      {
        id: +id!,
        formData: {
          insurance_body_info: {
            insurance_expiry_date: convertPersianToGregorian(
              data?.insurance_body_info?.insurance_expiry_date!,
            ),
            insurance_number: data?.insurance_body_info?.insurance_number,
            insurance_start_date: convertPersianToGregorian(
              data?.insurance_body_info?.insurance_start_date!,
            ),
          },
          insurance_property_info: {
            insurance: +data?.insurance_property_info?.insurance?.value,
            insurance_expiry_date: convertPersianToGregorian(
              data?.insurance_property_info?.insurance_expiry_date!,
            ),
            insurance_expiry_date_last_year: convertPersianToGregorian(
              data?.insurance_property_info?.insurance_expiry_date_last_year!,
            ),
            insurance_number: data?.insurance_property_info?.insurance_number,
            insurance_start_date: convertPersianToGregorian(
              data?.insurance_property_info?.insurance_start_date!,
            ),
          },
        },
      },
      {
        onSuccess: () => {
          navigate(-1);
          clientQuery?.invalidateQueries({
            queryKey: getBodyInsuranceOptions({ id: +id! }).queryKey,
          });
        },
      },
    );
  };
  useEffect(() => {
    if (BodyInsuranceData) {
      methods.reset({
        insurance_body_info: {
          insurance_expiry_date: BodyInsuranceData?.insurance_body_info
            ?.insurance_expiry_date
            ? convertTimestampToShamsi(
                BodyInsuranceData?.insurance_body_info?.insurance_expiry_date,
              )
            : null,
          insurance_number:
            BodyInsuranceData?.insurance_body_info?.insurance_number,
          insurance_start_date: BodyInsuranceData?.insurance_body_info
            ?.insurance_start_date
            ? convertTimestampToShamsi(
                BodyInsuranceData?.insurance_body_info?.insurance_start_date,
              )
            : null,
          insurance: {
            label: BodyInsuranceData?.insurance_body_info?.insurance
              ?.name as string,
            value: BodyInsuranceData?.insurance_body_info?.insurance
              ?.id as number,
          },
        },
        insurance_property_info: {
          insurance: {
            label: BodyInsuranceData?.insurance_property_info?.insurance
              ?.name as string,
            value: BodyInsuranceData?.insurance_property_info?.insurance
              ?.id as number,
          },
          insurance_expiry_date: BodyInsuranceData?.insurance_property_info
            ?.insurance_expiry_date
            ? convertTimestampToShamsi(
                BodyInsuranceData?.insurance_property_info
                  ?.insurance_expiry_date,
              )
            : null,
          insurance_expiry_date_last_year: BodyInsuranceData
            ?.insurance_property_info?.insurance_expiry_date_last_year
            ? convertTimestampToShamsi(
                BodyInsuranceData?.insurance_property_info
                  ?.insurance_expiry_date_last_year,
              )
            : null,
          insurance_number:
            BodyInsuranceData?.insurance_property_info?.insurance_number,
          insurance_start_date: BodyInsuranceData?.insurance_property_info
            ?.insurance_start_date
            ? convertTimestampToShamsi(
                BodyInsuranceData?.insurance_property_info
                  ?.insurance_start_date,
              )
            : null,
        },
      });
    }
  }, [BodyInsuranceData]);

  return {
    insurances,
    isPending,
    submitHandler,
    methods,
    setName,
    mutationPending,
    bodyPending,
  };
};

export default useEditBodyInsurance;
